import script from "./ProductTypeManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductTypeManage.vue?vue&type=script&lang=ts&setup=true"

import "./ProductTypeManage.vue?vue&type=style&index=0&id=10e56030&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10e56030"]])

export default __exports__